import { render, staticRenderFns } from "./EmbedPage.vue?vue&type=template&id=46449d1d&scoped=true"
import script from "./EmbedPage.vue?vue&type=script&lang=js"
export * from "./EmbedPage.vue?vue&type=script&lang=js"
import style0 from "./EmbedPage.vue?vue&type=style&index=0&id=46449d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46449d1d",
  null
  
)

export default component.exports